import store  from '../store'
import connect_api from '../connect/connect_api';

function log_login(callback) {
    const state = store.getState();
    let log_login_params = state.logsR.log_login;
    let params = {
        search:log_login_params.search_string,
        list_pagination:log_login_params.list_pagination
    };
    connect_api.sPOST('/logs/log_login',params,function(error, response){
        if (error) {
            console.log(error);
            callback(error,false);
        } else {
            store.dispatch({
                type: 'LOG_LOGIN_SEARCH',
                data: response.api_data
            });
            callback(false,true);
        }
    });
}

function log_controllers(callback) {
    const state = store.getState();
    let log_controllers_params = state.logsR.log_controllers;
    let params = {
        search:log_controllers_params.search_string,
        list_pagination:log_controllers_params.list_pagination
    };
    connect_api.sPOST('/logs/log_controllers',params,function(error, response){
        if (error) {
            console.log(error);
            callback(error,false);
        } else {
            store.dispatch({
                type: 'LOG_CONTROLLERS_SEARCH',
                data: response.api_data
            });
            callback(false,true);
        }
    });
}

export default  {
    log_login : log_login,
    log_controllers: log_controllers
}